import {
  Button,
  Circle,
  Heading,
  Icon,
  Link,
  Spinner,
  StackDivider,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { CheckIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { BookingService } from "../services/booking.service";
import { Helmet } from "react-helmet";
import { IBooking } from "../types/types";
import { PiQrCode } from "react-icons/pi";
import QrModal from "../components/QrModal";
import moment from "moment";

const bookingService = new BookingService();

const BookingStarted = () => {
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [searchParams] = useSearchParams();
  const [bookingId, setBookingId] = useState<string | false>();
  const [booking, setBooking] = useState<IBooking>();

  useEffect(() => {
    const bookingId = searchParams.get("id");

    if (bookingId) {
      setBookingId(bookingId);
    } else {
      setBookingId(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  useEffect(() => {
    if (bookingId) {
      getBookingData(bookingId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingId]);

  useEffect(() => {
    if (booking && booking.status !== "active") {
      navigate("/bookings");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [booking]);

  const getBookingData = async (id: string) => {
    const { data } = await bookingService.get(id);
    console.log("[getBookingData] booking", booking);

    setBooking(data.data);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Booking started - SALA</title>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <VStack w={"full"} spacing={8} alignItems={"center"} p={4}>
        {!bookingId || !booking ? (
          <Spinner />
        ) : (
          <>
            <VStack justifyContent={"center"} alignItems={"center"}>
              <Circle size="60px" bg={"green.100"} color={"green.500"}>
                <Icon as={CheckIcon} boxSize={"35%"} />
              </Circle>
              <Heading as="h1">¡Reserva confirmada!</Heading>
              <Text color={"gray.600"}>
                Aquí tienes los detalles de tu reserva
              </Text>
            </VStack>
            <VStack
              spacing={3}
              justifyContent={"start"}
              alignItems={"start"}
              w={"full"}
              py={6}
              bgColor={"gray.100"}
              borderRadius={"xl"}
              divider={<StackDivider borderColor={"gray.200"} />}
            >
              {[
                {
                  label: "Locker asignado",
                  children: (
                    <Text fontWeight={"medium"}>{booking.locker_id}</Text>
                  ),
                },
                {
                  label: "Hora de inicio",
                  children: (
                    <Text fontWeight={"medium"}>
                      {moment(booking.start_time).format("DD/MM/YYYY HH:mm")}
                    </Text>
                  ),
                },
              ].map((row) => (
                <VStack
                  key={row.label}
                  spacing={0}
                  justifyContent={"start"}
                  alignItems={"start"}
                  w={"full"}
                  px={6}
                >
                  <Text color={"gray.600"} fontSize={"small"}>
                    {row.label}
                  </Text>
                  <>{row.children}</>
                </VStack>
              ))}
            </VStack>

            <VStack w={"full"} spacing={4}>
              <Button
                size={"lg"}
                w={"full"}
                colorScheme={"gray"}
                borderRadius={"full"}
                fontWeight={"medium"}
                onClick={() => navigate("/bookings")}
              >
                Ver mis reservas
              </Button>
              <Button
                size={"lg"}
                w={"full"}
                colorScheme={"brand"}
                borderRadius={"full"}
                leftIcon={<Icon as={PiQrCode} color={"white"} boxSize={"6"} />}
                onClick={onOpen}
              >
                Abrir locker
              </Button>
              <Text textAlign={"center"} fontSize={"small"} color={"gray.600"}>
                Deberás enseñar tu QR para poder abrir tu locker. Podrás verlo
                cuando quieras en la página de{" "}
                <Link href="/bookings" color={"brand.500"}>
                  reservas <ExternalLinkIcon />
                </Link>
                .
              </Text>
            </VStack>
          </>
        )}
      </VStack>

      {bookingId && (
        <QrModal
          booking_id={bookingId}
          isOpen={isOpen}
          onClose={(options) => {
            onClose();

            if (options?.redirect) {
              navigate(options.redirect);
            }
          }}
        />
      )}
    </>
  );
};

export default BookingStarted;
